import { NotFound } from '@pages/not-found'
import React from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'

const routes = [
	"/login",
	"/sign-up",
	"/sign-up-teacher",
	"/waiting-confirm",
	"/waiting-restore",
	"/waiting-confirm-teacher",
	"/verify-email/:token",
	"/unsubscribe/:token",
	"/reset-password/:email/:token",
	"/forgot-password",
]

export const RedirectsFromDashboard = () => {
	return (
		<Routes>
			{routes.map(el => (
				<Route path={el} key={el} element={<Navigate to='/' />} />
			))}
			<Route path="*" element={<NotFound />}/>
		</Routes>
	)
}
